/* HUSHLY KIDS : upsell du tiroir de panier.
   Six pieges du panier Dawn traites ici :
   1. #CartDrawer est recree a chaque ajout  -> tout est delegue sur `document`,
      aucun ecouteur n'est pose sur un noeud du tiroir.
   2. renderContents() ouvre le tiroir       -> on ne l'appelle pas, on remplace
      nous-memes .drawer__inner et l'icone de panier.
   3. la page /cart ne se rafraichit jamais  -> on demande aussi les sections
      main-cart-items et main-cart-footer quand elles sont sur la page.
   4. data-quantity-variant-id sur toutes les lignes -> pose en Liquid dans
      snippets/cart-drawer.liquid, verifie ligne par ligne.
   5. une remise « achetez X obtenez Y » n'ecrit aucune propriete de ligne
      -> on ne s'appuie sur aucune propriete pour savoir ce qui est offert.
   6. une variante a 0,00 vaut quantite illimitee offerte
      -> aucun cadeau n'est construit ici, chaque ajout est une variante payante.
   Refonte 10/09/2026 : chemin `change` (carte « Add a 2nd pillow ») = retrait de
   la ligne par sa cle PUIS ajout de la variante du pack suivant, en deux requetes
   (/cart/change.js ne change pas la variante d'une ligne). Si l'ajout echoue, on
   remet l'ancienne variante (risque 4 du blueprint). Sur /cart, on n'ouvre jamais
   le tiroir (piege 2).
   T12 : la carte oreiller porte des pastilles de TAILLE. Meme taille que la ligne
   existante -> bascule de pack (chemin `change`, le moins cher) ; taille differente
   -> ajout d'une ligne pack 1 (chemin `add`). Le prix, le sous-titre et le badge de
   la carte suivent la pastille (recut). La housse offerte se choisit dans le tiroir :
   dans la carte quand elle est PROPOSEE (proprietes posees sur la ligne ajoutee) et
   sous la sous-ligne housse quand elle est DEBLOQUEE (giftApply -> /cart/change.js,
   jeu de proprietes renvoye ENTIER car change.js le remplace).
   Reprise T8 : aucun texte en dur ; les messages d'erreur viennent des
   data-attributes de <cart-drawer> (data-hkc-err-update, data-hkc-err-add),
   poses par snippets/cart-drawer.liquid depuis les reglages du theme.
*/
(function () {
  'use strict';

  var BUSY = false;

  function cartRoot() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  // 3. sur /cart les sections ne s'appellent pas 'main-cart-items' : leur vrai
  //    identifiant est dans data-id (templates/cart.json les nomme cart-items
  //    et cart-footer). Demander le mauvais nom rend la page muette.
  function mainCartIds() {
    var ids = {};
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) ids.items = items.dataset.id;
    if (footer && footer.dataset.id) ids.footer = footer.dataset.id;
    return ids;
  }

  function sectionsWanted() {
    var s = ['cart-drawer', 'cart-icon-bubble'];
    var ids = mainCartIds();
    if (ids.items) s.push(ids.items);
    if (ids.footer) s.push(ids.footer);
    return s;
  }

  function swapInner(html, sourceSelector, target) {
    if (!target) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector(sourceSelector);
    if (!src) return;
    target.innerHTML = src.innerHTML;
  }

  function applySections(sections) {
    if (!sections) return;

    // 2. on remplace nous-memes, sans passer par renderContents qui rouvre le tiroir
    if (sections['cart-drawer']) {
      var inner = document.querySelector('cart-drawer .drawer__inner');
      if (inner) {
        var scroller = inner.querySelector('.hkc-scroll');
        var keep = scroller ? scroller.scrollTop : 0;
        swapInner(sections['cart-drawer'], '.drawer__inner', inner);
        var again = inner.querySelector('.hkc-scroll');
        if (again) again.scrollTop = keep;
      }
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var drawer = document.querySelector('cart-drawer');
      var fresh = doc.querySelector('cart-drawer');
      if (drawer && fresh) drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) swapInner(sections['cart-icon-bubble'], '.shopify-section', bubble);
    }

    // 3. la page /cart, si on y est : lignes ET pied, sinon le total diverge
    var ids = mainCartIds();
    [['main-cart-items', ids.items], ['main-cart-footer', ids.footer]].forEach(function (pair) {
      var host = document.getElementById(pair[0]);
      if (!host || !pair[1] || !sections[pair[1]]) return;
      var zone = host.querySelector('.js-contents');
      var src = new DOMParser().parseFromString(sections[pair[1]], 'text/html').querySelector('.js-contents');
      if (zone && src) zone.innerHTML = src.innerHTML;
      host.classList.remove('is-empty');
      /* 13/10/2026 : sur /cart le bouton « Secure checkout · total » est HORS de .js-contents : apres un
         ajout depuis /cart (carte oreiller, carte taie) il gardait l'ancien total. On recopie son libelle
         et son etat depuis la section fraiche, sans toucher aux boutons Shop Pay / PayPal voisins. */
      if (pair[0] === 'main-cart-footer') {
        var fresh = new DOMParser().parseFromString(sections[pair[1]], 'text/html').querySelector('#checkout.hkc-checkout');
        var cur = host.querySelector('#checkout.hkc-checkout');
        if (fresh && cur) {
          var fs = fresh.querySelector('span'), cs = cur.querySelector('span');
          if (fs && cs) cs.textContent = fs.textContent;
          cur.disabled = fresh.disabled;
        }
      }
    });

    // T19, piege 1 : .drawer__inner et .js-contents viennent d'etre remplaces, donc la
    // bande d'annulation rendue par Liquid est neuve et vide. On la repeint depuis l'etat.
    paintUndo();
    agesSavedMark();
    sizeGate();
    foldRestore();
    caseCheck();
  }

  // 24/09 : sur /cart, le bouton de paiement est hors de la zone redessinee : on applique
  // ici le meme blocage que le Liquid (une taille manque -> paiement et paiement express bloques).
  /* 25/09 (Antonin, audit des housses) : une meme housse (taille + motif) repartie sur plusieurs
     lignes se paie plus cher que le lot (ex. lot 1 + lot 2 = 36.98 au lieu du lot de 3 a 33.99).
     Apres chaque action du panier (et au chargement s'il y a une housse), si un groupe n'est pas
     en lots optimaux (lots de 3 puis un seul reste en quantite 1), on lance le regroupement de
     assets/hushly-cart-merge.js (hkNormalizeCart), en silence, puis on redessine tiroir et /cart. */
  var CASEFIX = false;
  function caseCheck() {
    var M = window.HK_MERGE;
    if (CASEFIX || !M || !M.cases || typeof window.hkNormalizeCart !== 'function') return;
    CASEFIX = true;
    fetch(cartRoot() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var K = M.cases, idx = {}, g = {};
        K.variants.forEach(function (v) { idx[v.id] = v; });
        (cart.items || []).forEach(function (it) {
          if (it.handle !== K.handle) return;
          var pr = it.properties || {};
          if (Object.keys(pr).some(function (k) { return k.charAt(0) !== '_' && pr[k]; })) return;
          var v = idx[it.variant_id];
          if (!v) return;
          var key = v.age + '|' + v.print;
          (g[key] = g[key] || []).push({ p: v.pack, q: it.quantity });
        });
        var need = Object.keys(g).some(function (key) {
          var L = g[key], n = 0;
          L.forEach(function (x) { n += x.p * x.q; });
          var rem = n % K.top;
          var small = L.filter(function (x) { return x.p !== K.top; });
          if (!rem) return small.length > 0;
          return !(small.length === 1 && small[0].p === rem && small[0].q === 1);
        });
        if (!need) return null;
        window.__hkMergeQuiet = true;
        return window.hkNormalizeCart()
          .then(function () {
            window.__hkMergeQuiet = false;
            return fetch(window.location.pathname + '?sections=' + sectionsWanted().join(','), { cache: 'no-store' });
          })
          .then(function (r) { return r.json(); })
          .then(function (sections) { applySections(sections); });
      })
      .catch(function () {})
      .then(function () { CASEFIX = false; window.__hkMergeQuiet = false; });
  }
  (function caseCheckOnLoad() {
    function go() { if (document.querySelector('select[data-hkc-cesel]')) setTimeout(caseCheck, 400); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
    else go();
  })();

  /* 25/09 (Antonin) : housse offerte repliee. « Change » / « Done » ouvrent et ferment ;
     l'etat ouvert est garde par cle (rang de ligne + numero de housse) pour survivre au
     redessin du tiroir apres un choix de motif ou de taille. */
  var FOLD = window.__hkcFold || (window.__hkcFold = {});
  function foldRestore() {
    document.querySelectorAll('[data-hkc-fold]').forEach(function (w) {
      var on = !!FOLD[w.getAttribute('data-hkc-fold')];
      w.classList.toggle('is-open', on);
      var c = w.querySelector('.hkc-gfold__ch');
      if (c) c.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hkc-foldbtn]');
    if (!b) return;
    e.preventDefault();
    var w = b.closest('[data-hkc-fold]');
    if (!w) return;
    FOLD[w.getAttribute('data-hkc-fold')] = !w.classList.contains('is-open');
    foldRestore();
  });

  function sizeGate() {
    if (!onCartPage()) return;
    var miss = !!document.querySelector('#main-cart-items .hkc-ages__row--missing');
    var hasItems = !!document.querySelector('#main-cart-items .cart-item');
    var ck = document.getElementById('checkout');
    if (ck) ck.disabled = miss || !hasItems;
    var dyn = document.querySelector('.cart__dynamic-checkout-buttons');
    if (dyn) dyn.style.display = miss ? 'none' : '';
    var cta = ck && ck.parentNode;
    var msg = cta && cta.querySelector('.hkc-missing');
    if (miss && cta && !msg) {
      msg = document.createElement('p');
      msg.className = 'hkc-missing';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Choose a size for each pillow to continue.';
      cta.insertBefore(msg, ck);
    } else if (!miss && msg) {
      msg.parentNode.removeChild(msg);
    }
  }

  // 24/09 (choix B) : apres un enregistrement de tailles, « Size saved » sous la ligne
  // dont les menus portent exactement les tailles choisies (le tiroir vient d'etre redessine).
  function agesSavedMark() {
    var s = window.__hkcAgesSaved;
    if (!s || Date.now() - s.t > 15000) return;
    window.__hkcAgesSaved = null;
    var boxes = document.querySelectorAll(onCartPage() ? '#main-cart-items [data-hkc-ages]' : 'cart-drawer [data-hkc-ages]');
    for (var i = 0; i < boxes.length; i++) {
      var vals = [].slice.call(boxes[i].querySelectorAll('select')).map(function (x) { return x.value; });
      if (vals.join('|') !== s.ages.join('|')) continue;
      var ok = document.createElement('p');
      ok.className = 'hkc-ages__ok';
      ok.setAttribute('role', 'status');
      ok.textContent = '\u2713 Size saved';
      boxes[i].appendChild(ok);
      setTimeout(function () { if (ok.parentNode) ok.parentNode.removeChild(ok); }, 3000);
      break;
    }
  }

  // textes rendus par Liquid sur <cart-drawer> (reglages hkc_err_*)
  function text(name) {
    var d = document.querySelector('cart-drawer');
    return (d && d.getAttribute('data-hkc-' + name)) || '';
  }

  // T13 : sur /cart la boite est #HkcCartErrors (rendue par main-cart-footer) ;
  // dans le tiroir c'est #CartDrawer-CartErrors. Sans elle, un echec ne disait rien.
  function errBox() {
    return document.getElementById('HkcCartErrors') || document.getElementById('CartDrawer-CartErrors');
  }

  function announce(el, msg) {
    var box = errBox();
    if (!box) return;
    box.textContent = msg || '';
    // T13 : un message hors ecran ne se lit pas. On l'amene sous les yeux.
    if (msg && typeof box.scrollIntoView === 'function') {
      try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { box.scrollIntoView(); }
    }
  }

  // T13 : filet de securite. Si la reponse ne revient jamais (reseau coupe, fetch
  // avale par un script tiers), BUSY restait a true et le tiroir etait fige pour de
  // bon, sans un mot. Au dela de WATCH_MS on rend la main et on le dit.
  var WATCH_MS = 8000;
  var WATCH = null;
  /* 26/09/2026 (Antonin) : REVERIFICATION avant tout message d'echec. Une reponse lente ou perdue
     ne veut pas dire que Shopify n'a rien fait. On relit le vrai panier (cart.js) et on redessine
     le tiroir (et /cart) depuis le serveur ; le message ne s'affiche que si le panier est
     IDENTIQUE a avant l'action (empreinte data-hkc-sig posee par snippets/cart-drawer.liquid). */
  var WBEFORE = null;
  function sigNow() {
    var n = document.querySelector('cart-drawer [data-hkc-sig]');
    return n ? n.getAttribute('data-hkc-sig') : null;
  }
  function sigOf(c) {
    return c.item_count + '|' + c.total_price + '|' +
      (c.items || []).map(function (i) { return i.key + ':' + i.quantity + ','; }).join('');
  }
  function verify(el, which, before) {
    return Promise.all([
      fetch(cartRoot() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }),
      fetch(window.location.pathname + '?sections=' + sectionsWanted().join(','), { cache: 'no-store' }).then(function (r) { return r.json(); })
    ])
      .then(function (res) {
        applySections(res[1]);
        var changed = before != null && sigOf(res[0]) !== before;
        announce(el, changed ? '' : text(which));
        return changed;
      })
      .catch(function () { announce(el, text(which)); return false; });
  }
  function watchdog(el, which) {
    stopWatch();
    var before = WBEFORE = sigNow();
    WATCH = setTimeout(function () {
      WATCH = null;
      // on garde la main pendant la relecture, mais jamais plus de WATCH_MS de plus
      var settled = false;
      var guard = setTimeout(function () {
        if (settled) return;
        settled = true; BUSY = false; clearBusy();
        announce(el, text(which));
      }, WATCH_MS);
      verify(el, which, before).then(function () {
        if (settled) return;
        settled = true; clearTimeout(guard); BUSY = false; clearBusy();
      });
    }, WATCH_MS);
  }
  function stopWatch() {
    if (WATCH) { clearTimeout(WATCH); WATCH = null; }
  }

  function onCartPage() {
    return !!document.getElementById('main-cart-items');
  }

  function openDrawer() {
    if (onCartPage()) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open();
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function parseProps(raw) {
    if (!raw) return undefined;
    try {
      var o = JSON.parse(raw);
      return (o && typeof o === 'object' && Object.keys(o).length) ? o : undefined;
    } catch (e) { return undefined; }
  }

  // T12 : proprietes finales = base de la carte + choix des pastilles [data-hkc-prop]
  // encore visibles (un bloc housse masque ne compte pas : la ligne pack 1 ajoutee
  // dans une autre taille ne debloque aucune housse).
  function overlayProps(base, host) {
    var out = {};
    if (base) Object.keys(base).forEach(function (k) { out[k] = base[k]; });
    if (host) {
      host.querySelectorAll('[data-hkc-opt][data-hkc-prop]').forEach(function (o) {
        if (!o.classList.contains('is-on')) return;
        var blk = o.closest('[data-hkc-giftblock]');
        if (blk && blk.hasAttribute('hidden')) return;
        out[o.getAttribute('data-hkc-prop')] = o.getAttribute('data-hkc-val') || '';
      });
    }
    return Object.keys(out).length ? out : undefined;
  }

  function clearBusy() {
    document
      .querySelectorAll('[data-hkc-step][aria-busy="true"],[data-hkc-add][aria-busy="true"],[data-hkc-change][aria-busy="true"],[data-hkc-cta][aria-busy="true"],[data-hkc-giftedit][aria-busy="true"],[data-hkc-rm][aria-busy="true"],[data-hkc-undoback][aria-busy="true"]')
      .forEach(function (b) { b.removeAttribute('aria-busy'); });
  }

  function setBox(el, txt) {
    if (!el) return;
    el.textContent = txt || '';
    if (txt) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  /* ------------------------------------------------------------------
     T19. ANNULER UN RETRAIT DE LIGNE (« Removed ... Undo »)

     Avant : un appui sur la corbeille (jusqu'a 101,95 GBP) partait sans un mot,
     sans confirmation et sans retour possible. Le retrait de Dawn est donc
     intercepte en phase de CAPTURE sur `document` (piege 1 : on ne pose jamais
     d'ecouteur sur un noeud du tiroir, il est recree a chaque mutation), la
     ligne est photographiee AVANT le retrait par les data-attributes poses en
     Liquid (variante, quantite, titre, PROPRIETES de ligne : housse offerte,
     age, motif), puis une bande discrete propose de la remettre.
     La bande vit dans un noeud rendu par Liquid, `[data-hkc-undobar]`, present
     des deux cotes (tiroir et /cart) et hors du bloc « panier vide » pour
     survivre au retrait de la derniere ligne. Elle est repeinte apres chaque
     applySections, effacee apres le delai du reglage ou a la fermeture du tiroir.
     ------------------------------------------------------------------ */
  var UNDO = null;   // { id, quantity, title, props }
  var UNDO_T = null;

  function undoDelayMs() {
    var d = document.querySelector('cart-drawer');
    var v = d ? Number(d.getAttribute('data-hkc-undo-delay')) : 0;
    if (!v || v < 1) v = 8;
    return v * 1000;
  }

  function clearUndo() {
    if (UNDO_T) { clearTimeout(UNDO_T); UNDO_T = null; }
    UNDO = null;
    paintUndo();
  }

  function paintUndo() {
    var bars = document.querySelectorAll('[data-hkc-undobar]');
    if (!bars.length) return;
    var d = document.querySelector('cart-drawer');
    var tpl = (d && d.getAttribute('data-hkc-undo-text')) || '';
    var label = (d && d.getAttribute('data-hkc-undo-btn')) || '';
    bars.forEach(function (bar) {
      bar.textContent = '';
      if (!UNDO || !label) { bar.setAttribute('hidden', ''); return; }
      var p = document.createElement('p');
      p.className = 'hkc-undo__t';
      p.textContent = tpl ? tpl.split('[item]').join(UNDO.title || '') : (UNDO.title || '');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hkc-undo__b';
      b.setAttribute('data-hkc-undoback', '');
      b.textContent = label;
      bar.appendChild(p);
      bar.appendChild(b);
      bar.removeAttribute('hidden');
    });
  }

  // `item.properties | json` de Shopify ne rend PAS un objet : c'est un tableau de
  // paires [cle, valeur]. Envoye tel quel a /cart/add.js, il repond
  // « expected Array to be a Hash: properties » et la ligne ne revient pas.
  // On accepte les deux formes et on ecarte les valeurs vides.
  function propsFromAttr(raw) {
    var v = null;
    try { v = JSON.parse(raw); } catch (e) { return undefined; }
    if (!v) return undefined;
    var out = {};
    if (Array.isArray(v)) {
      v.forEach(function (pair) {
        if (Array.isArray(pair) && pair[0] && pair[1] !== null && pair[1] !== '') out[pair[0]] = pair[1];
      });
    } else if (typeof v === 'object') {
      Object.keys(v).forEach(function (k) {
        if (v[k] !== null && v[k] !== '') out[k] = v[k];
      });
    }
    return Object.keys(out).length ? out : undefined;
  }

  /* 25/09/2026 (Antonin : « le moins complexe pour le client ») : UNE ligne par housse payante.
     On regle le NOMBRE de housses d'une taille + motif ; la repartition en variantes 1/2/3
     (« How many? ») se fait ici : lots de 3, puis un seul reste. Une seule requete
     /cart/update.js par identifiant de variante (ajoute, change ou retire), donc pas d'etat
     intermediaire. targets = { "age|motif": nombre }. */
  function caseApply(targets, el) {
    var M = window.HK_MERGE;
    if (BUSY || !M || !M.cases) return;
    var K = M.cases, upd = {}, ok = true;
    Object.keys(targets).forEach(function (key) {
      var cut = key.lastIndexOf('|'), age = key.slice(0, cut), pr = key.slice(cut + 1);
      var n = Math.max(0, parseInt(targets[key], 10) || 0);
      var q3 = Math.floor(n / K.top), rem = n % K.top;
      var seen = {};
      K.variants.forEach(function (v) {
        if (v.age !== age || v.print !== pr) return;
        seen[v.pack] = v;
        upd[v.id] = v.pack === K.top ? q3 : (v.pack === rem ? 1 : 0);
      });
      if (q3 && !seen[K.top]) ok = false;
      if (rem && !seen[rem]) ok = false;
    });
    if (!ok) { announce(el, text('err-update')); return; }
    BUSY = true;
    if (el) { el.setAttribute('aria-busy', 'true'); announce(el, ''); }
    watchdog(el, 'err-update');
    postJSON((window.routes && window.routes.cart_update_url) || '/cart/update', {
      updates: upd,
      sections: sectionsWanted(),
      sections_url: window.location.pathname
    })
      .then(function (state) {
        if (state.status) { announce(el, state.description || state.message || text('err-update')); return; }
        applySections(state.sections);
      })
      .catch(function () { verify(el, 'err-update', WBEFORE); })
      .finally(function () { stopWatch(); BUSY = false; clearBusy(); });
  }
  function caseSetFrom(el) {
    var t = {};
    t[el.getAttribute('data-hkc-cset')] = el.getAttribute('data-hkc-cn');
    caseApply(t, el);
  }
  /* menus Size / Print : tout le nombre part vers la housse choisie, en s'ajoutant a ce qui y est */
  function caseMove(src, dst, n, el) {
    if (!src || !dst || src === dst) return;
    var M = window.HK_MERGE;
    if (!M || !M.cases) return;
    fetch(cartRoot() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var have = 0;
        (cart.items || []).forEach(function (it) {
          M.cases.variants.forEach(function (v) {
            if (v.id === it.variant_id && (v.age + '|' + v.print) === dst) have += v.pack * it.quantity;
          });
        });
        var t = {};
        t[src] = 0;
        t[dst] = have + n;
        caseApply(t, el);
      })
      .catch(function () { verify(el, 'err-update', sigNow()); });
  }
  window.__hkCaseMove = caseMove;

  function removeLine(el) {
    if (BUSY) return;
    var key = el.getAttribute('data-hkc-rm');
    if (!key) return;
    var snap = {
      id: Number(el.getAttribute('data-hkc-rm-id')),
      quantity: Number(el.getAttribute('data-hkc-rm-qty')) || 1,
      title: el.getAttribute('data-hkc-rm-title') || '',
      props: propsFromAttr(el.getAttribute('data-hkc-rm-props'))
    };
    BUSY = true;
    el.setAttribute('aria-busy', 'true');
    announce(el, '');
    watchdog(el, 'err-update');
    postJSON((window.routes && window.routes.cart_change_url) || '/cart/change', {
      id: key,
      quantity: 0,
      sections: sectionsWanted(),
      sections_url: window.location.pathname
    })
      .then(function (state) {
        if (state.status) {
          announce(el, state.description || state.message || text('err-update'));
          return;
        }
        if (UNDO_T) { clearTimeout(UNDO_T); UNDO_T = null; }
        UNDO = snap;
        applySections(state.sections);   // repeint la bande
        UNDO_T = setTimeout(clearUndo, undoDelayMs());
      })
      .catch(function () { verify(el, 'err-update', WBEFORE); })
      .finally(function () { stopWatch(); BUSY = false; clearBusy(); });
  }

  function undoBack(button) {
    if (BUSY || !UNDO) return;
    var snap = UNDO;
    BUSY = true;
    button.setAttribute('aria-busy', 'true');
    announce(button, '');
    watchdog(button, 'undo-err');
    var item = { id: snap.id, quantity: snap.quantity };
    if (snap.props) item.properties = snap.props;
    postJSON((window.routes && window.routes.cart_add_url) || '/cart/add', {
      items: [item],
      sections: sectionsWanted(),
      sections_url: window.location.pathname
    })
      .then(function (state) {
        if (state.status) {
          announce(button, state.description || state.message || text('undo-err'));
          return;
        }
        if (UNDO_T) { clearTimeout(UNDO_T); UNDO_T = null; }
        UNDO = null;
        applySections(state.sections);
      })
      .catch(function () { announce(button, text('undo-err')); })
      .finally(function () { stopWatch(); BUSY = false; clearBusy(); });
  }

  // fermeture du tiroir : la bande n'a plus lieu d'etre. Piege 1 : <cart-drawer>
  // est le seul noeud qui survit aux mutations, c'est lui qu'on observe.
  function watchDrawerClose() {
    var d = document.querySelector('cart-drawer');
    if (!d || !window.MutationObserver) return;
    // On efface sur la TRANSITION ouvert -> ferme, jamais sur l'etat « ferme ».
    // Sur /cart le tiroir n'est jamais ouvert et applySections lui repose sa classe
    // is-empty a chaque mutation : tester l'etat effacait la bande aussitot posee.
    var wasActive = d.classList.contains('active');
    new MutationObserver(function () {
      var now = d.classList.contains('active');
      if (wasActive && !now && UNDO) clearUndo();
      wasActive = now;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerClose);
  } else {
    watchDrawerClose();
  }

  // Capture sur document : le retrait de Dawn (<cart-remove-button>) ne doit PAS
  // partir. stopPropagation en capture empeche l'ecouteur pose sur la cible.
  document.addEventListener(
    'click',
    function (event) {
      var rm = event.target.closest && event.target.closest('[data-hkc-rm]');
      if (!rm) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      if (rm.hasAttribute('data-hkc-rmgroup')) { caseSetFrom(rm); return; }   // 25/09 : housse sur plusieurs lignes
      removeLine(rm);
    },
    true
  );

  /* ------------------------------------------------------------------
     T20. LE DEUXIEME CHEMIN DE SUPPRESSION : le bouton « moins » a quantite 1.

     Le champ de quantite de Dawn porte min="0" : a 1, un appui sur « moins »
     descend a 0 et cart-items.updateQuantity supprime la ligne. C'est un AUTRE
     chemin que la corbeille (quantity-input -> change, pas cart-remove-button),
     il partait donc sans la bande « Removed / Undo ». Meme traitement ici :
     on intercepte en CAPTURE sur document, et on rebranche sur removeLine avec
     la photographie de ligne deja posee en Liquid sur la corbeille de la MEME
     rangee (variante, quantite, titre, proprietes de ligne). Rien n'est
     duplique et la restauration est identique a celle de la corbeille.
     Au-dessus de 1, on ne touche a rien : Dawn decremente normalement.
     ------------------------------------------------------------------ */
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      var moins = event.target.closest('.quantity__button[name="minus"]');
      if (!moins) return;
      if (moins.hasAttribute('data-hkc-step')) return;   // T26 : changement de pack, pas un retrait
      if (moins.hasAttribute('data-hkc-cset')) return;   // 25/09 : housse regroupee, nombre - 1
      var boite = moins.closest('quantity-input') || moins.parentElement;
      var champ = boite && boite.querySelector('input.quantity__input, input[name="updates[]"]');
      if (!champ) return;
      var q = parseInt(champ.value, 10);
      if (!(q <= 1)) return;              // pas le dernier pas : Dawn continue
      var rangee = moins.closest('.hkc-line, .cart-item');
      var rm = rangee && rangee.querySelector('[data-hkc-rm]');
      if (!rm) return;                    // pas de photographie : on laisse Dawn faire
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      removeLine(rm);
    },
    true
  );

  /* ------------------------------------------------------------------
     T26. + ET - D'UNE LIGNE OREILLER CHANGENT DE PACK.
     Les attributs sont poses en Liquid par snippets/hushly-cart-packstep.liquid.
     Capture sur document : le bouton de <quantity-input> de Dawn ne doit pas
     partir (il poserait une quantite 2 au prix unitaire). Au plus gros pack,
     le + desactive est avale sans rien faire. Au pack 1, le - n'a pas
     d'attribut et retombe sur le retrait avec « Undo » (T20).
     ------------------------------------------------------------------ */
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      var cset = event.target.closest('[data-hkc-cset]');
      if (cset && !cset.hasAttribute('data-hkc-rmgroup')) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        caseSetFrom(cset);
        return;
      }
      var pas = event.target.closest('[data-hkc-step]');
      var bute = event.target.closest('[data-hkc-step-off]');
      if (!pas && !bute) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      if (pas) change(pas);
    },
    true
  );

  /* ------------------------------------------------------------------
     T33. PLUS DE BULLE NATIVE « This item has a minimum of 1 ».
     Taper 0 dans une quantite du tiroir ou de /cart faisait afficher par Dawn la bulle
     grise du navigateur (reportValidity), hors charte, et rien ne se passait. Regle :
       - 0 ou moins : c'est un retrait, meme chemin que la corbeille et que le « moins »
         a 1 (T20) : la ligne part avec la bande « Removed · Undo » ;
       - vide ou invalide : on remet la quantite d'avant, sans rien dire.
     Capture sur document : l'ecouteur de <cart-items> de Dawn ne voit pas l'evenement.
     ------------------------------------------------------------------ */
  document.addEventListener(
    'change',
    function (event) {
      var f = event.target;
      if (!f || !f.matches || !f.matches('input.quantity__input')) return;
      if (!f.closest('cart-drawer, #main-cart-items, cart-items')) return;
      var raw = String(f.value).trim();
      var n = parseInt(raw, 10);
      if (raw !== '' && !isNaN(n) && n >= 1) return;        // Dawn fait son travail
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      f.value = f.getAttribute('value') || '1';
      try { f.setCustomValidity(''); } catch (e) {}
      if (raw !== '' && !isNaN(n) && n <= 0) {
        var row = f.closest('.hkc-line, .cart-item');
        var rm = row && row.querySelector('[data-hkc-rm]');
        if (rm) removeLine(rm);
      }
    },
    true
  );

  // T12 : la pastille de taille reconfigure le bouton de la carte oreiller.
  var CTA_KEYS = ['mode', 'vid', 'line', 'qty', 'qtyback', 'vid2', 'qty2', 'old', 'props', 'oldprops'];
  function recut(card, opt) {
    var cta = card.querySelector('[data-hkc-cta]');
    if (!cta) return;
    CTA_KEYS.forEach(function (k) {
      var v = opt.getAttribute('data-hkc-' + k);
      if (v === null || v === '') cta.removeAttribute('data-hkc-' + k);
      else cta.setAttribute('data-hkc-' + k, v);
    });
    var was = card.querySelector('[data-hkc-was]');
    if (was) {
      var w = opt.getAttribute('data-hkc-was') || '';
      was.textContent = w;
      if (w) was.removeAttribute('hidden');
      else was.setAttribute('hidden', '');
    }
    setBox(card.querySelector('[data-hkc-subbox]'), opt.getAttribute('data-hkc-sub'));
    setBox(card.querySelector('[data-hkc-badgebox]'), opt.getAttribute('data-hkc-badge'));
    var keep = opt.getAttribute('data-hkc-mode') === 'change';
    card.querySelectorAll('[data-hkc-giftblock]').forEach(function (b) {
      if (keep) b.removeAttribute('hidden');
      else b.setAttribute('hidden', '');
    });
  }

  // T12 : housse offerte DEJA au panier -> on reecrit les proprietes de la ligne.
  // /cart/change.js REMPLACE le jeu de proprietes : on renvoie la base entiere.
  function giftApply(box) {
    if (BUSY) return;
    var index = Number(box.getAttribute('data-hkc-index'));
    if (!index) return;
    var props = overlayProps(parseProps(box.getAttribute('data-hkc-base')), box);
    if (!props) return;
    BUSY = true;
    box.setAttribute('aria-busy', 'true');
    announce(box, '');
    watchdog(box, 'err-update');
    var payload = {
      line: index,
      properties: props,
      sections: sectionsWanted(),
      sections_url: window.location.pathname
    };
    var qty = Number(box.getAttribute('data-hkc-qty'));
    if (qty > 0) payload.quantity = qty;
    postJSON((window.routes && window.routes.cart_change_url) || '/cart/change', payload)
      .then(function (state) {
        if (state.status) {
          announce(box, state.description || state.message || text('err-update'));
          return;
        }
        applySections(state.sections);
      })
      .catch(function () { verify(box, 'err-update', WBEFORE); })
      .finally(function () { stopWatch(); BUSY = false; clearBusy(); });
  }

  // changement de pack : retrait de la ligne (cle) puis ajout de la variante cible.
  // T22 : `qty` est la quantite AJOUTEE de la cible (1 en regroupement), jamais la
  // quantite de la ligne retiree ; `qtyBack` sert au rattrapage si l'ajout echoue ;
  // `vid2`/`qty2` portent le pack du reste quand un regroupement ne tombe pas juste.
  function change(button) {
    if (BUSY) return;
    var lineKey = button.getAttribute('data-hkc-line');
    var variantId = Number(button.getAttribute('data-hkc-vid'));
    var qty = Number(button.getAttribute('data-hkc-qty')) || 1;
    var qtyBack = Number(button.getAttribute('data-hkc-qtyback')) || qty;
    var vid2 = Number(button.getAttribute('data-hkc-vid2')) || 0;
    var qty2 = Number(button.getAttribute('data-hkc-qty2')) || 1;
    var oldId = Number(button.getAttribute('data-hkc-old'));
    var props = overlayProps(parseProps(button.getAttribute('data-hkc-props')), button.closest('[data-hkc-card]'));
    var oldProps = parseProps(button.getAttribute('data-hkc-oldprops'));
    if (!lineKey || !variantId) return;
    BUSY = true;
    button.setAttribute('aria-busy', 'true');
    announce(button, '');
    watchdog(button, 'err-update');

    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var sections = sectionsWanted();

    /* T37 : carte de regroupement -> plusieurs lignes a retirer en UNE requete
       (/cart/update, updates: { cle: 0, ... }), puis l'ajout du pack. */
    var lines = (button.getAttribute('data-hkc-lines') || '').split(',').filter(function (k) { return k; });
    var oldLines = null;
    try { oldLines = JSON.parse(button.getAttribute('data-hkc-oldlines') || 'null'); } catch (e) { oldLines = null; }
    // lignes a remettre si l'operation echoue a mi-chemin
    function backList() {
      var back = { id: oldId, quantity: qtyBack };
      if (oldProps) back.properties = oldProps;
      if (oldLines && oldLines.length) {
        return oldLines.map(function (o) {
          var it = { id: Number(o.id), quantity: Number(o.quantity) || 1 };
          if (o.properties && Object.keys(o.properties).length) it.properties = o.properties;
          return it;
        });
      }
      return [back];
    }
    // 24/09 : cles des lignes affichees AVANT l'operation (photographie posee sur chaque corbeille)
    var before = {};
    document.querySelectorAll('[data-hkc-rm]').forEach(function (b) { before[b.getAttribute('data-hkc-rm')] = true; });
    var gone = [lineKey].concat(lines);

    /* 24/09 FILET RESEAU. Un changement de pack = retrait PUIS ajout. Si le reseau coupe entre
       les deux (ou si une reponse se perd alors que le serveur a bien fait le travail), le
       .catch ne savait rien de l'etat reel : la ligne pouvait avoir disparu du panier pendant
       que l'ecran montrait encore l'ancien pack. On relit donc le panier sur le serveur :
         - l'ancienne ligne est toujours la  -> rien n'a ete perdu ;
         - une NOUVELLE ligne de la variante cible est apparue -> l'ajout est passe ;
         - ni l'une ni l'autre -> on remet l'ancienne ligne (jamais de doublon).
       Puis on redessine le tiroir (et /cart) depuis le serveur, pour que l'ecran dise vrai. */
    function recover() {
      return fetch(cartRoot() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var oldThere = items.some(function (it) { return gone.indexOf(it.key) >= 0; });
          var newThere = items.some(function (it) { return it.variant_id === variantId && !before[it.key]; });
          if (newThere) return true;           // l'operation a abouti : pas de message d'erreur
          if (oldThere) return false;
          return postJSON(addUrl, { items: backList() }).then(function () { return false; });
        })
        .then(function (done) {
          return fetch(window.location.pathname + '?sections=' + sectionsWanted().join(','), { cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (secs) { applySections(secs); return done; });
        })
        .catch(function () { return false; });
    }

    var first;
    if (lines.length > 1) {
      var ups = {};
      lines.forEach(function (k) { ups[k] = 0; });
      first = postJSON((window.routes && window.routes.cart_update_url) || '/cart/update', { updates: ups });
    } else {
      first = postJSON(changeUrl, { id: lineKey, quantity: 0 });
    }
    first
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message || 'change failed');
        var item = { id: variantId, quantity: qty };
        if (props) item.properties = props;
        var items = [item];
        if (vid2) items.push({ id: vid2, quantity: qty2 });
        return postJSON(addUrl, { items: items, sections: sections, sections_url: window.location.pathname });
      })
      .then(function (state) {
        if (state.status) {
          // l'ajout a echoue : on remet l'ancienne ligne pour ne rien perdre
          return postJSON(addUrl, { items: backList(), sections: sections, sections_url: window.location.pathname })
            .then(function (s2) {
              if (s2.sections) applySections(s2.sections);
              announce(button, state.description || state.message || text('err-update'));
            });
        }
        // 2. rendu uniquement sur la reponse du add, jamais entre les deux requetes
        applySections(state.sections);
        if (!button.hasAttribute('data-hkc-noopen')) openDrawer();   // T26 : pas sur /cart
      })
      .catch(function () {
        return recover().then(function (done) { if (!done) announce(button, text('err-update')); });
      })
      .finally(function () {
        stopWatch();
        BUSY = false;
        clearBusy();
      });
  }

  function add(variantId, button, props) {
    if (BUSY) return;
    BUSY = true;
    if (button) button.setAttribute('aria-busy', 'true');
    announce(button, '');
    watchdog(button, 'err-add');

    var item = { id: Number(variantId), quantity: 1 };
    if (props) item.properties = props;
    var body = JSON.stringify({
      items: [item],
      sections: sectionsWanted(),
      sections_url: window.location.pathname
    });

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) {
          announce(button, state.description || state.message || '');
          return;
        }
        // on rafraichit tout nous-memes ; publier cartUpdate ferait re-rendre
        // cart-drawer-items par cart.js par-dessus, et remplacerait le tiroir
        // deja a jour par un second aller-retour reseau.
        applySections(state.sections);
        openDrawer();
      })
      .catch(function () {
        verify(button, 'err-add', WBEFORE);
      })
      .finally(function () {
        stopWatch();
        BUSY = false;
        clearBusy();
      });
  }

  /* 25/09/2026 : carte housse payante, taille ET motif au choix (snippets/hushly-cart-upsell).
     La variante se deduit du couple « age|motif » (data-hkc-cmap). Si ce couple est deja une
     ligne du panier (data-hkc-incart), le bouton propose le lot suivant et declenchera le +
     de cette ligne, pour ne jamais faire payer deux lignes a 12.99 au lieu du lot. */
  function stepFor(key) {
    var all = document.querySelectorAll('cart-drawer [data-hkc-step="up"][data-hkc-line]');
    for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-hkc-line') === key) return all[i];
    return null;
  }
  function comboApply(card) {
    var map = parseProps(card.getAttribute('data-hkc-cmap')) || {};
    var inc = parseProps(card.getAttribute('data-hkc-incart')) || {};
    var pr = card.querySelector('[data-hkc-group="cprint"].is-on');
    var ag = card.querySelector('[data-hkc-group="cage"].is-on');
    if (!pr || !ag) return;
    var prv = pr.getAttribute('data-hkc-cval'), agv = ag.getAttribute('data-hkc-cval');
    var key = agv + '|' + prv;
    var v = map[key];
    var same = inc[key];
    if (same && !stepFor(same.k)) same = null;
    var note = card.querySelector('[data-hkc-same]');
    if (v) {
      card.setAttribute('data-hkc-vid', v[0]);
      card.querySelectorAll('[data-hkc-add]').forEach(function (b) { b.setAttribute('data-hkc-vid', v[0]); });
    }
    card.querySelectorAll('[data-hkc-addlabel]').forEach(function (b) {
      b.removeAttribute('data-hkc-proxy');
      b.disabled = false;
      if (same) {
        b.setAttribute('data-hkc-proxy', same.k);
        b.textContent = 'Add one more \u00b7 ' + same.n + ' for ' + same.p;
      } else if (v) {
        b.textContent = 'Add ' + prv + ' \u00b7 ' + agv + ' \u00b7 ' + v[1];
      } else {
        b.disabled = true;
        b.textContent = 'Out of stock';
      }
    });
    if (note) {
      if (same) {
        note.textContent = "You already have this one in your basket. We'll add it to the same line.";
        note.hidden = false;
      } else {
        note.textContent = '';
        note.hidden = true;
      }
    }
  }

  // 1. delegation sur document : rien ne se perd quand le tiroir est reconstruit
  document.addEventListener('click', function (event) {
    var opt = event.target.closest && event.target.closest('[data-hkc-opt]');
    if (opt) {
      event.preventDefault();
      var card = opt.closest('[data-hkc-card], [data-hkc-giftedit]');
      if (!card) return;
      var group = opt.getAttribute('data-hkc-group') || '';
      card.querySelectorAll('[data-hkc-opt][data-hkc-group="' + group + '"]').forEach(function (o) {
        o.classList.toggle('is-on', o === opt);
        o.setAttribute('aria-pressed', o === opt ? 'true' : 'false');
      });
      var vid = opt.getAttribute('data-hkc-vid');
      var price = opt.getAttribute('data-hkc-price');
      var img = opt.getAttribute('data-hkc-img');
      var thumb = card.querySelector('[data-hkc-thumb]');
      if (thumb && img) thumb.src = img;
      if (vid) card.setAttribute('data-hkc-vid', vid);
      var priceEl = card.querySelector('[data-hkc-pricebox]');
      if (priceEl && price) {
        var nowEl = priceEl.querySelector('[data-hkc-now]');
        if (nowEl) nowEl.textContent = price;
        else priceEl.textContent = price;
      }
      var addCta = card.querySelector('[data-hkc-add]');
      if (addCta && vid) addCta.setAttribute('data-hkc-vid', vid);
      /* 24/09 (tuiles housse) : il y a aussi un bouton pleine largeur, qui dit le motif */
      if (vid) card.querySelectorAll('[data-hkc-add]').forEach(function (b) { b.setAttribute('data-hkc-vid', vid); });
      var lab = opt.getAttribute('data-hkc-label');
      if (lab) card.querySelectorAll('[data-hkc-addlabel]').forEach(function (b) { b.textContent = lab; });
      if (opt.hasAttribute('data-hkc-mode')) recut(card, opt);
      if (card.hasAttribute('data-hkc-giftedit')) giftApply(card);
      if (card.hasAttribute('data-hkc-cmap')) comboApply(card);
      return;
    }

    /* 24/09 : carte housse payante repliee quand une housse est deja offerte, un clic la deplie */
    var more = event.target.closest && event.target.closest('[data-hkc-more]');
    if (more) {
      event.preventDefault();
      var mcard = more.closest('[data-hkc-card]');
      if (mcard) mcard.classList.add('is-open');
      more.setAttribute('aria-expanded', 'true');
      return;
    }

    var ub = event.target.closest && event.target.closest('[data-hkc-undoback]');
    if (ub) {
      event.preventDefault();
      undoBack(ub);
      return;
    }

    var q = event.target.closest && event.target.closest('[data-hkc-instalments]');
    if (q) {
      event.preventDefault();
      var panel = document.getElementById(q.getAttribute('aria-controls'));
      if (panel) {
        var open = panel.hasAttribute('hidden');
        if (open) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var cta = event.target.closest && event.target.closest('[data-hkc-cta]');
    if (cta) {
      event.preventDefault();
      if (cta.getAttribute('data-hkc-mode') === 'change') {
        change(cta);
      } else {
        var cid = cta.getAttribute('data-hkc-vid');
        if (cid) add(cid, cta, overlayProps(parseProps(cta.getAttribute('data-hkc-props')), cta.closest('[data-hkc-card]')));
      }
      return;
    }

    var chg = event.target.closest && event.target.closest('[data-hkc-change]');
    if (chg) {
      event.preventDefault();
      change(chg);
      return;
    }

    var btn = event.target.closest && event.target.closest('[data-hkc-add]');
    if (btn) {
      event.preventDefault();
      /* 25/09 : meme housse que celle du panier -> on passe par le + de sa ligne (prix du lot) */
      var px = btn.getAttribute('data-hkc-proxy');
      if (px) {
        var st = stepFor(px);
        if (st) { st.click(); return; }
      }
      var host = btn.closest('[data-hkc-card]');
      var id = btn.getAttribute('data-hkc-vid') || (host && host.getAttribute('data-hkc-vid'));
      if (id) add(id, btn, overlayProps(parseProps(btn.getAttribute('data-hkc-props')), host));
    }
  });
})();


/* ------------------------------------------------------------------
   T25. LA JAUGE EVOLUE A L'ECRAN.
   La barre est rendue en Liquid et le tiroir est REMPLACE a chaque mutation
   (Dawn renderContents, applySections) : la nouvelle barre naissait
   directement a sa largeur finale, la transition CSS n'avait jamais rien a
   animer et le client ne voyait jamais la jauge avancer. On memorise donc la
   derniere largeur vue (une pour le tiroir, une pour /cart) ; toute barre qui
   apparait repart de cette largeur et glisse jusqu'a la sienne, et les jalons
   qui viennent de s'allumer marquent le coup. Dans le tiroir, si celui-ci
   vient de s'ouvrir, on attend la fin de son glissement pour que l'avancee
   se voie. Rien ne bouge si l'utilisateur demande moins d'animations.
   ------------------------------------------------------------------ */
(function () {
  var LAST = {};
  var LAST_ON = {};
  var openedAt = 0;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function key(bar) { return bar.closest('cart-drawer') ? 'drawer' : 'page'; }
  function onList(bar) {
    return Array.prototype.map.call(bar.querySelectorAll('.hkc-bar__m'), function (m) {
      return m.classList.contains('is-on') ? 1 : 0;
    });
  }
  function widthOf(bar) {
    var f = bar.querySelector('.hkc-bar__fill');
    return f ? (f.style.width || '0%') : '0%';
  }
  function record(bar) {
    var k = key(bar);
    LAST[k] = widthOf(bar);
    LAST_ON[k] = onList(bar);
    bar.__hkcSeen = true;
  }
  function play(bar, from, before, target) {
    var fill = bar.querySelector('.hkc-bar__fill');
    var now = LAST_ON[key(bar)] || [];
    if (fill) fill.style.transition = '';
    var wait = 0;
    if (key(bar) === 'drawer') {
      var since = Date.now() - openedAt;
      if (since < 480) wait = 480 - since;
    }
    setTimeout(function () {
      if (fill) fill.style.width = target;
      var marks = bar.querySelectorAll('.hkc-bar__m');
      now.forEach(function (v, i) {
        if (v && !before[i] && marks[i]) {
          var m = marks[i];
          setTimeout(function () {
            m.classList.add('is-on', 'is-new');
            setTimeout(function () { m.classList.remove('is-new'); }, 700);
          }, 380);
        }
      });
    }, wait);
  }
  function animate(bar) {
    if (bar.__hkcSeen) return;
    var k = key(bar);
    var from = (k in LAST) ? LAST[k] : '0%';
    var before = LAST_ON[k] || [];
    var target = widthOf(bar);
    record(bar);
    if (reduce) return;
    // Recul IMMEDIAT a l'ancienne largeur : l'observateur tourne avant la peinture,
    // la nouvelle barre ne s'affiche donc jamais pleine une image avant de
    // repartir (scintillement mesure au banc : 0, 33, 0, 3...).
    var fill = bar.querySelector('.hkc-bar__fill');
    if (fill && from !== target) {
      fill.style.transition = 'none';
      fill.style.width = from;
      void fill.offsetWidth;
    }
    // Un jalon qui vient de s'allumer ne s'allume qu'a l'ARRIVEE de la barre :
    // il repart eteint maintenant, play() le rallume au moment ou elle le touche.
    var marks = bar.querySelectorAll('.hkc-bar__m');
    onList(bar).forEach(function (v, i) {
      if (v && !before[i] && marks[i]) marks[i].classList.remove('is-on');
    });
    // un tour de rendu : l'observateur de classe du tiroir a pu noter l'ouverture
    requestAnimationFrame(function () { play(bar, from, before, target); });
  }
  function scan(n) {
    if (!n || n.nodeType !== 1) return;
    if (n.matches && n.matches('.hkc-bar')) animate(n);
    if (n.querySelectorAll) Array.prototype.forEach.call(n.querySelectorAll('.hkc-bar'), animate);
  }
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.hkc-bar'), record);
    if (!window.MutationObserver) return;
    new MutationObserver(function (list) {
      list.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, scan); });
    }).observe(document.body, { childList: true, subtree: true });
    // Piege 1 : <cart-drawer> est le seul noeud qui survit, c'est lui qu'on observe.
    var d = document.querySelector('cart-drawer');
    if (d) {
      var was = d.classList.contains('active');
      new MutationObserver(function () {
        var is = d.classList.contains('active');
        if (is && !was) openedAt = Date.now();
        was = is;
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ------------------------------------------------------------------
   16/09/2026 : volet « Different ages? » du tiroir (snippets/cart-drawer.liquid).
   Au changement d'un age, on recalcule la variante (pack a l'age de l'oreiller 1)
   et les proprietes (Pillow N age), puis le bouton devient un vrai data-hkc-step :
   le clic passe alors par change() (capture T26) comme un + ou un -.
   ------------------------------------------------------------------ */
(function () {
  if (window.__hkcAges) return; window.__hkcAges = 1;
  /* 25/09 (Antonin) : housse payante au panier, menus Size / Print (snippets/hushly-cart-case-edit).
     La valeur d'une option = variante cible (meme lot) ; on la pose sur le bouton cache et on
     le clique : change() retire la ligne et ajoute la cible, avec rattrapage. Capture + arret,
     comme pour les tailles d'oreiller, sinon cart-items de Dawn y voit une quantite. */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('select[data-hkc-cesel]')) return;
    e.stopPropagation();
    var o = sel.options[sel.selectedIndex];
    if (!o || !o.value) return;
    var go = sel.closest('.hkc-cedit').querySelector('[data-hkc-cego]');
    if (!go || !window.__hkCaseMove) return;
    window.__hkCaseMove(go.getAttribute('data-hkc-cmove'), o.value, parseInt(go.getAttribute('data-hkc-cn'), 10) || 1, go);
  }, true);
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-hkc-ages] select')) return;
    /* capture + arret : sinon cart-items de Dawn traite ce changement comme une quantite
       (validateQuantity -> event.target.select(), erreur sur un <select>). */
    e.stopPropagation();
    var box = sel.closest('[data-hkc-ages]');
    var btn = box.querySelector('.hkc-ages__save');
    var map = {};
    (box.getAttribute('data-hkc-vmap') || '').split('||').forEach(function (p) {
      var kv = p.split('::'); if (kv.length === 2) map[kv[0]] = kv[1];
    });
    var base = {};
    try { base = JSON.parse(box.getAttribute('data-hkc-base') || '{}'); } catch (err) { base = {}; }
    var ages = [].slice.call(box.querySelectorAll('select')).map(function (s) { return s.value; });
    var vid = map[ages[0]];
    if (!vid) return;
    ages.slice(1).forEach(function (a, i) { if (a) base['Pillow ' + (i + 2) + ' age'] = a; });
    /* 27/09/2026 (une housse offerte par oreiller) : la housse offerte N suit la taille
       que le client vient de choisir pour l'oreiller N. Elle reste modifiable ensuite (« Change »). */
    var hkSels = [].slice.call(box.querySelectorAll('select')), hkI = hkSels.indexOf(sel);
    if (hkI >= 0 && sel.value && base.hasOwnProperty('Free pillowcase ' + (hkI + 1) + ' age')) base['Free pillowcase ' + (hkI + 1) + ' age'] = sel.value;
    btn.setAttribute('data-hkc-vid', vid);
    btn.setAttribute('data-hkc-props', JSON.stringify(base));
    btn.removeAttribute('data-hkc-step-pending');
    btn.setAttribute('data-hkc-step', 'edit');
    btn.disabled = false;
    /* 24/09 (choix B) : menus toujours visibles, enregistrement immediat, sans bouton.
       Rien n'est envoye si les tailles choisies sont celles deja enregistrees. */
    if (box.closest('[data-hkc-ages-auto]')) {
      var same = [].slice.call(box.querySelectorAll('select')).every(function (s) {
        var d = [].slice.call(s.options).filter(function (o) { return o.defaultSelected; })[0];
        return d ? d.value === s.value : false;
      });
      if (same) return;
      window.__hkcAgesSaved = { ages: ages, t: Date.now() };
      btn.click();
    }
  }, true);
})();
/* 12/10/2026 (Antonin) : carte d'upsell « 2nd / 3rd pillow » : l'age se choisit au clic.
   « Add to basket » ouvre l'etape [data-hkc-agestep] ; un tap sur un age ecrit « Pillow N age » et l'age
   de la taie debloquee dans data-hkc-props, coche la pastille d'age du bloc taie masque (relue par
   overlayProps), puis relance le clic du bouton (laisse passer grace a data-hkc-ageok). Ecoute sur window
   en capture : passe avant le gestionnaire du bouton (document). */
(function () {
  /* 12/10/2026 (Antonin) : l'etape s'ouvrait coupee par le pied du tiroir. On fait defiler la zone
     scrollable (en douceur, sauf prefers-reduced-motion) pour la centrer dans la partie visible
     au-dessus du pied, puis halo 2 fois (classe is-pulse, CSS dans hk-panier-minuteur). */
  function scroller(el) {
    for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
      var o = getComputedStyle(n).overflowY;
      if ((o === 'auto' || o === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return null;
  }
  function showStep(step) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sc = scroller(step);
    if (sc) {
      var sr = sc.getBoundingClientRect(), top = Math.max(sr.top, 0), bottom = Math.min(sr.bottom, window.innerHeight);
      var foot = document.querySelector('cart-drawer .drawer__footer, cart-drawer .cart-drawer__footer');
      if (foot) { var fr = foot.getBoundingClientRect(); if (fr.top > top && fr.top < bottom) bottom = fr.top; }
      var keep = document.querySelector('cart-drawer .hkc-keep');   /* bandeau colle en haut du tiroir */
      if (keep && keep.offsetParent) { var kr = keep.getBoundingClientRect(); if (kr.bottom > top && kr.bottom < bottom) top = kr.bottom; }
      var r = step.getBoundingClientRect();
      var delta = (r.top + r.height / 2) - (top + (bottom - top) / 2);
      if (r.height > bottom - top) delta = r.top - top - 8;
      /* fin de la zone : on ajoute sous la carte la place qui manque pour centrer (retiree a Cancel ; le tiroir est redessine apres l'ajout) */
      var card = step.closest('[data-hkc-card]'), room = sc.scrollHeight - sc.clientHeight - sc.scrollTop;
      if (card && delta > room) card.style.marginBottom = Math.ceil(delta - room) + 'px';
      sc.scrollTo({ top: sc.scrollTop + delta, behavior: reduce ? 'auto' : 'smooth' });
    } else if (step.scrollIntoView) {
      step.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
    step.classList.remove('is-pulse'); void step.offsetWidth; step.classList.add('is-pulse');
    setTimeout(function () { step.classList.remove('is-pulse'); }, 1400);
  }
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var cta = t.closest('[data-hkc-cta]');
    if (cta) {
      var card = cta.closest('[data-hkc-card]'), step = card && card.querySelector('[data-hkc-agestep]');
      if (!step) return;
      if (cta.hasAttribute('data-hkc-ageok')) { cta.removeAttribute('data-hkc-ageok'); return; }
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      step.hidden = false; card.classList.add('is-agestep');
      showStep(step);
      return;
    }
    var cancel = t.closest('[data-hkc-agecancel]');
    if (cancel) {
      e.preventDefault(); e.stopPropagation();
      var c0 = cancel.closest('[data-hkc-card]'), s0 = cancel.closest('[data-hkc-agestep]');
      if (s0) s0.hidden = true; if (c0) { c0.classList.remove('is-agestep'); c0.style.marginBottom = ''; }
      return;
    }
    var pick = t.closest('[data-hkc-agepick]');
    if (!pick) return;
    e.preventDefault(); e.stopPropagation();
    var st = pick.closest('[data-hkc-agestep]'), cd = pick.closest('[data-hkc-card]'), btn = cd && cd.querySelector('[data-hkc-cta]');
    if (!st || !btn || btn.getAttribute('aria-busy') === 'true') return;
    var age = pick.getAttribute('data-hkc-agepick'), p = {};
    try { p = JSON.parse(btn.getAttribute('data-hkc-props') || '{}') || {}; } catch (x) { return; }
    p['Pillow ' + st.getAttribute('data-hkc-n') + ' age'] = age;
    (st.getAttribute('data-hkc-slots') || '').split(',').forEach(function (n) {
      if (!n) return;
      var key = 'Free pillowcase ' + n + ' age';
      p[key] = age;
      cd.querySelectorAll('[data-hkc-opt][data-hkc-prop="' + key + '"]').forEach(function (o) {
        var on = o.getAttribute('data-hkc-val') === age;
        o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    btn.setAttribute('data-hkc-props', JSON.stringify(p));
    pick.setAttribute('aria-busy', 'true');
    btn.setAttribute('data-hkc-ageok', '1');
    btn.click();
  }, true);
})();
